import type { ApiResponse } from "../../shared/schemas/api";

export class ApiError extends Error {
  constructor(
    message: string,
    readonly code: string,
    readonly status: number,
    readonly details?: unknown,
  ) {
    super(message);
  }
}

function getCsrfToken(): string | undefined {
  return document.cookie
    .split("; ")
    .find((item) => item.startsWith("xlr8r_csrf="))
    ?.split("=")
    .slice(1)
    .join("=");
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const csrf = getCsrfToken();
    if (csrf) headers.set("x-csrf-token", csrf);
  }
  const response = await fetch(path, { ...init, headers, credentials: "include" });
  const payload = await response.json() as ApiResponse<T>;
  if (!payload.success) {
    throw new ApiError(payload.error.message, payload.error.code, response.status, payload.error.details);
  }
  return payload.data;
}

export function jsonBody(value: unknown): Pick<RequestInit, "body" | "headers"> {
  return {
    body: JSON.stringify(value),
    headers: { "content-type": "application/json" },
  };
}
